import React, { useState } from "react";
import styled, { css } from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

import { theme } from "styles";
// components
import Text from "components/ui/Text";
import ImagePicker from "./ImagePicker";
import Confirm from "components/ui/Confirm";
import { Button, RightArrow } from "components/common";
import { logout } from "api/signin";

// redux
import { resetReduxState } from "redux/slices/user/userSlice";

const AccountOverview = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.user);
  const [avatar, setAvatar] = useState(userInfo.imageUrl || "");

  const handleLogoutClick = () => {
    Confirm(`로그아웃하시겠습니까?`, {
      title: "로그아웃",
      button: {
        left: { name: "취소", color: "gray50" },
        right: { name: "로그아웃", color: "danger" },
      },
      callback: (result) => {
        if (result) {
          logout()
            .then((res) => {
              if (res) {
                dispatch(resetReduxState());
                navigate("/entrance/signin");
              }
            })
            .catch((e) => {
              dispatch(resetReduxState());
              navigate("/entrance/signin");
            });
        }
      },
    });
  };

  return (
    <Wrapper>
      <ImagePicker avatar={avatar} setAvatar={setAvatar} />

      <Fields>
        <div>
          <p className="main" >아이디</p>
          <p className="secondary" data-clarity-mask="True">{userInfo?.phoneNumber}</p>
        </div>
        <div onClick={() => navigate("/all/account/name")}>
          <p className="main">이름</p>
          <div>
            <p className="secondary" data-clarity-mask="True">{userInfo?.name}</p>
            <RightArrow />
          </div>
        </div>
        <div onClick={() => navigate("/all/account/password-check")}>
          <p className="main">비밀번호 변경</p>
          <RightArrow />
        </div>
        <Divider />
        <RemoveAccountCard>
          <Text
            color="gray40"
            fontSize="14px"
            fontWeight="500"
            css={css`
              margin-right: 8px;
            `}
            onClick={() => navigate("/all/account/removal")}
          >
            관리자 앱 계정 탈퇴
          </Text>
          <RightArrow
            size="S"
            onClick={() => navigate("/all/account/removal")}
          />
        </RemoveAccountCard>
      </Fields>

      <LogoutButtonWrapper>
        <Button
          variant="contained"
          className="square"
          padding="16px"
          text="로그아웃"
          backgroundColor="#FFFFFF"
          color="#515458"
          border="1px solid #E1E6ED"
          onClick={handleLogoutClick}
        />
      </LogoutButtonWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px 24px 0px 20px;
`;

const Fields = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;

  > div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 56px;
  }

  div > div {
    display: flex;
    flex-direction: row;
    p {
      margin-right: 8px;
    }
  }

  p.main {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: #26282b;
  }

  p.secondary {
    font-size: 16px;
    line-height: 24px;
    color: #70747d;
  }
`;

const LogoutButtonWrapper = styled.div`
  display: flex;
  padding: 0 20px;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 40px;
`;

const RemoveAccountCard = styled.div`
  height: 48px !important;
  display: flex;
  justify-content: flex-start !important;
  align-items: center;
`;

const Divider = styled.span`
  border-top: 1px solid ${theme.colors["line30"]};
  margin: 16px 0;
`;

export default AccountOverview;
